import { get } from "@insite/client-framework/Services/ApiService";

const customGetSnapshotUrl = `api/v1/customaccount/getsnapshotdata?t=${Date.now()}`;

export function getSnapShotData() {
    return get<any>(`${customGetSnapshotUrl}`);
}
